import { dataByIds } from '../../../data/glassData.js';

const filterMemories = (allMemories, searchTerm, typeFilter) => {
  let filteredMemories = allMemories;

  if (typeFilter && typeFilter !== 'all') {
    filteredMemories = filteredMemories.filter(
      memory => memory.personType === typeFilter
    );
  }

  if (searchTerm) {
    const lowerCaseSearchTerm = searchTerm.toLowerCase();

    filteredMemories = filteredMemories.filter(
      memory =>
        memory.name.toLowerCase().includes(lowerCaseSearchTerm) ||
        memory.text.toLowerCase().includes(lowerCaseSearchTerm) ||
        memory.relatedItems.reduce(
          (result, id) =>
            result ||
            dataByIds[id].title.toLowerCase().includes(lowerCaseSearchTerm),
          false
        )
    );
  }

  return filteredMemories;
};

const sortMemories = (filteredMemories, sort) => {
  if (sort === 'date:asc') {
    // Oldest First
    filteredMemories.sort(
      (a, b) => (a.submissionDate > b.submissionDate ? 1 : 0)
    );
  } else if (sort === 'name:asc') {
    // A First
    filteredMemories.sort((a, b) => a.name.localeCompare(b.name));
  } else if (sort === 'name:desc') {
    // Z First
    filteredMemories.sort((a, b) => b.name.localeCompare(a.name));
  } else {
    // Default is date:asc - Newest First
    filteredMemories.sort(
      (a, b) => (a.submissionDate < b.submissionDate ? 1 : 0)
    );
  }

  return filteredMemories;
};

export default function searchFilterAndSortMemories(
  memories,
  searchTerm,
  typeFilter,
  sortOrder
) {
  return sortMemories(
    filterMemories(memories, searchTerm, typeFilter),
    sortOrder
  );
}



// WEBPACK FOOTER //
// ./src/utils/search/memories.js